// extracted by mini-css-extract-plugin
module.exports = {"popsql__markdown":"markdown_popsql__markdown__LVhk3","links":"markdown_links__R_TGR"};